module.exports = __webpack_public_path__ + "static/media/IndhiraGandhi3.0e8dc827.jpeg";